module.exports = Jsw.skinUrl + "/icons/16/plesk/file-txt.png?9bfe434b7467e7d61abb4b3ae8adc711";